export class DeviceDetector {
	private isPhone: boolean;
	constructor() {
		this.isPhone = this.checkIfPhone();
		this.bindEvents();
	}

	checkIfPhone() {
		const ua = navigator.userAgent;

		// User agent проверка
		const isMobileUA = /iPhone|iPod|Android.*Mobile|Windows.*Phone/i.test(ua);
		const isTabletUA = /iPad|Android(?!.*Mobile)|Tablet/i.test(ua);

		// Проверка по размеру экрана
		const screenWidth = window.screen.width;
		const screenHeight = window.screen.height;
		const minDimension = Math.min(screenWidth, screenHeight);
		const maxDimension = Math.max(screenWidth, screenHeight);

		// Эмпирические правила для определения телефона
		const isSmallScreen = minDimension < 768;
		const isPhoneAspectRatio = maxDimension / minDimension > 1.6;

		const isStandalone = window.matchMedia('(display-mode: standalone)').matches
			|| (window.navigator as any).standalone === true;

		return isMobileUA || isSmallScreen || isPhoneAspectRatio  || isStandalone;
	}

	bindEvents() {
		window.addEventListener('resize', () => {
			this.isPhone = this.checkIfPhone();
		});

		window.addEventListener('orientationchange', () => {
			setTimeout(() => {
				this.isPhone = this.checkIfPhone();
			}, 300);
		});
	}

	shouldDisableDnD() {
		return this.isPhone;
	}
}

export const deviceDetector = new DeviceDetector();
export const IsDeviceMobile = deviceDetector.shouldDisableDnD();